import { render } from "./CrewDatabase.vue?vue&type=template&id=3dd66d8c"
import script from "./CrewDatabase.vue?vue&type=script&lang=js"
export * from "./CrewDatabase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__